if (!customElements.get('barakka-shipping-progress')) {
  customElements.define('barakka-shipping-progress', class extends HTMLElement {
    connectedCallback() {
      this.refresh = this.refresh.bind(this);
      this.refresh();
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
          if (event.cartData && typeof event.cartData.total_price === 'number') {
            if (this.controller) this.controller.abort();
            this.renderCart(event.cartData);
          }
          else this.refresh();
        });
      }
      this.notification = this.closest('cart-notification');
      if (this.notification) {
        this.observer = new MutationObserver(() => {
          if (this.notification.querySelector('.cart-notification.active')) this.refresh();
        });
        this.observer.observe(this.notification, { attributes: true, attributeFilter: ['class'], subtree: true });
      }
    }
    disconnectedCallback() {
      if (this.unsubscribe) this.unsubscribe();
      if (this.observer) this.observer.disconnect();
      if (this.controller) this.controller.abort();
    }
    async refresh() {
      if (this.controller) this.controller.abort();
      this.controller = new AbortController();
      try {
        const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart.js', {
          signal: this.controller.signal, headers: { Accept: 'application/json' }
        });
        if (!response.ok) return;
        const cart = await response.json();
        if (this.isConnected) this.renderCart(cart);
      } catch (error) {
        if (error.name !== 'AbortError') return;
      }
    }
    renderCart(cart) {
      const threshold = Number(this.dataset.threshold);
      const total = Number(cart.total_price);
      if (!Number.isFinite(total) || !Number.isFinite(threshold) || threshold <= 0) return;
      const currency = cart.currency || this.dataset.currency;
      this.hidden = currency !== 'EUR';
      if (this.hidden) return;
      const remaining = Math.max(0, threshold - total);
      const amount = new Intl.NumberFormat(document.documentElement.lang || 'fr', {
        style: 'currency', currency
      }).format(remaining / 100);
      const message = this.querySelector('.barakka-shipping-progress__message');
      const text = remaining > 0 ? this.dataset.remaining.replace('__AMOUNT__', amount) : this.dataset.success;
      if (message.textContent.trim() !== text.trim()) message.textContent = text;
      this.querySelector('progress').value = Math.min(100, Math.max(0, total / threshold * 100));
    }
  });
}
